import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getList() {
    return axiosIns.get('/admin/report_metrics')
  },
  create(params) {
    return axiosIns.post('/admin/report_metrics', { report_metric: snakecaseKeys(params) })
  },
  update(id, params) {
    return axiosIns.patch(`/admin/report_metrics/${id}`, { report_metric: snakecaseKeys(params) })
  },
  destroy(id) {
    return axiosIns.delete(`/admin/report_metrics/${id}`)
  },
  updatePositions(params) {
    return axiosIns.patch('/admin/report_metrics/update_positions', snakecaseKeys(params))
  },
}
